/**
 * App Config File
 */
let production_host = 'https://api.vspacehub.com'
let dev_host = 'https://dev.api.vspacehub.com'
let local_host = 'http://127.0.0.1:3030'
let host = production_host
const is_local = location.host.includes('localhost') || location.host.includes('127.0.0.1')
const is_dev = location.host.split('.')[0] === "dev" || location.host.split('.')[1] === "dev"
if (is_dev)
	host = dev_host
if (is_local)
	// host = "http://127.0.0.1:4040"
	host = local_host
export default {
	// host: 'http://149.28.154.192:4040',
	production_host,
	dev_host,
	local_host,
	host: host,
	bikeTicketLogo: '/static/bike-ticket.png',                                   // App Logo,
	appLogo: '/static/img/site-logo.png',                                   // App Logo,
	darkLogo: '/static/img/site-dark-logo.png',							    // dark logo
	appLogo2: 'https://lumitechie.com/logo.png',                                    // App Logo 2 For Login & Signup Page
	brand: 'PMQLNT2025',                                        			        // Brand Name
	copyrightText: 'Tuan © 2025 All Rights Reserved.',                     // Copyright Text
	enableUserTour: process.env.NODE_ENV === 'production' ? true : false,   // Enable User Tour
	weatherApiId: 'b1b15e88fa797225412429c1c50c122a1',						// weather API Id
	weatherApiKey: '69b72ed255ce5efad910bd946685883a'						// weather APi key
}
